import { observer } from "mobx-react";
import { useTranslation } from "react-i18next";
import styles from "./index.module.scss";
import emptyImg from "../../assets/empty.png";
import i18next from "i18next";
interface emptyPageProps {
  externalStyles?: React.CSSProperties;
  externalImageStyles?: React.CSSProperties;
  emptyText?: string;
}

const emptyPage: React.FC<emptyPageProps> = observer(({ externalStyles, externalImageStyles, emptyText }) => {
  const { t } = useTranslation();
  return (
    <div className={styles.wrap} style={externalStyles}>
      <img src={emptyImg.src} alt="empty" style={externalImageStyles} />
      <div>{emptyText || `There's nothing more`}</div>
    </div>
  );
});

export default emptyPage;
